// const LOADER_SKIPPED = sessionStorage.getItem("site_loader_played") === "true";

document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  /* --------------------------------
     REGISTER PLUGINS
  -------------------------------- */
  gsap.registerPlugin(ScrollTrigger);

  if (typeof MotionPathPlugin !== "undefined") {
    gsap.registerPlugin(MotionPathPlugin);
  }

  /* --------------------------------
     ANIMATION MAP (DEFAULT MOTION)
  -------------------------------- */
  const animations = {
    "fade": { opacity: 0 },
    "fade-up": { y: 80, opacity: 0 },
    "fade-down": { y: -60, opacity: 0 },
    "fade-left": { x: 80, opacity: 0 },
    "fade-right": { x: -80, opacity: 0 },
    "scale-in": { scale: 0.85, opacity: 0 },
    "scale-up": { scale: 1.2, opacity: 0 }
  };

  const DEFAULTS = {
    duration: 0.9,
    //delay: LOADER_SKIPPED ? 0 : 0, // base default stays 0
    delay: 0, // base default stays 0
    ease: "power3.out",
    start: "top 70%"
  };

  /* =================================================
     CONTAINER-BASED STAGGER (GROUP ANIMATION)
  ================================================= */
  document.querySelectorAll("[data-animate-container]").forEach(container => {
    if (container.dataset.gsapDone) return;
    container.dataset.gsapDone = "true";

    const items = container.querySelectorAll(
      "[data-animate]:not([data-animate='stagger'])"
    );
    if (!items.length) return;

    const stagger = parseFloat(container.dataset.stagger) || 0;
    const start = container.dataset.start || DEFAULTS.start;
    const duration = parseFloat(container.dataset.duration) || DEFAULTS.duration;
    const ease = container.dataset.ease || DEFAULTS.ease;
  //   const delay = LOADER_SKIPPED
  // ? 0
  // : parseFloat(container.dataset.delay) || DEFAULTS.delay;
    const delay = parseFloat(container.dataset.delay) || DEFAULTS.delay;

  // Group items by their animation type
  const groups = {};

  items.forEach(el => {
    const type = el.dataset.animate || "fade";
    if (!groups[type]) groups[type] = [];
    groups[type].push(el);
  });

  // Create ONE shared ScrollTrigger
  const sharedTrigger = {
    trigger: container,
    start,
    once: true
  };

  // Animate each group with its own preset
  Object.entries(groups).forEach(([type, elements]) => {
    const baseVars = { ...(animations[type] || { opacity: 0 }) };

    // container-level overrides
    if (container.dataset.x) baseVars.x = parseFloat(container.dataset.x);
    if (container.dataset.y) baseVars.y = parseFloat(container.dataset.y);

    gsap.from(elements, {
      ...baseVars,
      duration,
      delay,
      ease,
      stagger,
      scrollTrigger: sharedTrigger,
      // 👇 element-specific overrides
      x: (i, el) =>
        el.dataset.x !== undefined
          ? parseFloat(el.dataset.x)
          : baseVars.x,
      y: (i, el) =>
        el.dataset.y !== undefined
          ? parseFloat(el.dataset.y)
          : baseVars.y
    });
  });
 });

  /* =================================================
     SINGLE ELEMENT ANIMATIONS
  ================================================= */
  document.querySelectorAll("[data-animate]").forEach(el => {
    const type = el.dataset.animate;

    if (type === "stagger") return;
    if (el.closest("[data-animate-container]")) return;
    if (el.dataset.gsapDone) return;
    el.dataset.gsapDone = "true";

    const fromVars = { ...(animations[type] || { opacity: 0 }) };

    /* 🔥 element-level motion override */
    if (el.dataset.x) fromVars.x = parseFloat(el.dataset.x);
    if (el.dataset.y) fromVars.y = parseFloat(el.dataset.y);

    const duration = parseFloat(el.dataset.duration) || DEFAULTS.duration;
  //   const delay = LOADER_SKIPPED
  // ? 0
  // : parseFloat(el.dataset.delay) || DEFAULTS.delay;
    const delay = parseFloat(el.dataset.delay) || DEFAULTS.delay;
    const ease = el.dataset.ease || DEFAULTS.ease;
    const start = el.dataset.start || DEFAULTS.start;

    const triggerType = el.dataset.trigger || "scroll";

    /* --------------------------------
       PAGE LOAD (HERO)
    -------------------------------- */
    // if (triggerType === "load") {
    //   gsap.from(el, {
    //     ...fromVars,
    //     duration,
    //     // delay: LOADER_SKIPPED ? 0 : delay,
    //     delay: delay,
    //     ease
    //   });
    //   return;
    // }
    if (triggerType === "load") {
      requestAnimationFrame(() => {
        gsap.from(el, {
          ...fromVars,
          duration,
          delay: 0, // force no delay
          ease
        });
      });
      return;
    }
    const scrollTrigger = {
      trigger: el,
      start,
      once: true
    };

    if (el.dataset.end) {
      scrollTrigger.end = el.dataset.end;
    }

    if (el.dataset.scrub !== undefined) {
      scrollTrigger.scrub =
        el.dataset.scrub === "true"
          ? true
          : parseFloat(el.dataset.scrub) || true;
      delete scrollTrigger.once;
    }

    gsap.from(el, {
      ...fromVars,
      duration,
      delay,
      ease,
      scrollTrigger
    });
  });

  /* =================================================
     LEGACY EXPLICIT STAGGER (OPTIONAL)
  ================================================= */
  document.querySelectorAll("[data-animate='stagger']").forEach(group => {
    if (group.dataset.gsapDone) return;
    group.dataset.gsapDone = "true";

    const items = Array.from(group.children).filter(Boolean);
    if (!items.length) return;

    const duration = parseFloat(group.dataset.duration) || 0.8;
    const stagger = parseFloat(group.dataset.stagger) || 0.15;
  //   const delay = LOADER_SKIPPED
  // ? 0
  // : parseFloat(group.dataset.delay) || 0;
    const delay =  parseFloat(group.dataset.delay) || 0;
    const start = group.dataset.start || "top 75%";

    gsap.from(items, {
      y: 40,
      opacity: 0,
      duration,
      delay,
      ease: "power3.out",
      stagger,
      scrollTrigger: {
        trigger: group,
        start,
        once: true
      }
    });
  });
});
